import React from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { Title, Text, Button, Loading } from 'ui';
import { removeInvite, useInvite } from 'api';
import "./index.css";


export default function RemoveInvite() {
  
  const history = useHistory();
  const match = useRouteMatch();
  const invite = useInvite(match.params.inviteId);
  
  if(!invite) {
    return <Loading/>;
  }
  
  async function remove() {
    await removeInvite(match.params.inviteId);
    history.push('../view');
  }
  
  function cancel() {
    history.push('../view');
  }
  
  
  return (
    <div className="removeinvite">
    
      <Title>Revoke Invitation</Title>
    
      <Text>Are you sure you want to revoke the invitation to {invite.email}?</Text>
        
      
      <div className="removeinvite-actions">
        <Button label="Remove" onClick={remove}/>
        <Button tertiary label="Cancel" onClick={cancel}/>
      </div>
      
    </div>
  );
}